'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
class ErrorHandler extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      showErrorComponent: false
    };
  }
  static getDerivedStateFromError() {
    // Trigger render to return null on any error (but tracking/side-effects are done in `componentDidCatch`)
    return {
      showErrorComponent: true
    };
  }
  componentDidCatch(error, info) {
    if (window.newrelic && window.newrelic.noticeError) {
      const {
        componentStack
      } = info || {};
      window.newrelic.noticeError(error, {
        componentStack
      });
    }
  }
  render() {
    const {
      children,
      errorComponent
    } = this.props;
    const {
      showErrorComponent
    } = this.state;
    if (showErrorComponent) {
      return errorComponent;
    }
    return children;
  }
}
ErrorHandler.propTypes = {
  children: PropTypes.node,
  errorComponent: PropTypes.node
};
export default ErrorHandler;